import { Injectable } from '@angular/core';
import { BaseDAO } from './baseDAO';
import { ConstantMan } from '../constantMan';
import { ApiHelper } from '../apiHelper';
import { Observable } from 'rxjs';
import { HttpHeaders } from '@angular/common/http';
import { Offer } from 'anchor-shared/lib/model/entity/offer';
import { CustomerAddOn } from 'anchor-shared/lib/model/entity/addOn';

@Injectable()
export class OfferDAO extends BaseDAO<Offer> {
  constructor(public readonly apiHelper: ApiHelper) {
    super(apiHelper, ConstantMan.API.RESOURCE.OFFER);
  }

  createOffers(
    charterId: number,
    publicId: string,
    offers: Partial<Offer>[],
  ): Observable<Offer[]> {
    let url: string =
      this.apiHelper.getServiceName() +
      this.getResource() +
      `/create/${charterId}/${publicId}`;
    const method = 'POST';
    const headers: HttpHeaders = this.apiHelper.getDefaultHeader();
    const data = {
      offers,
    };
    return this.apiHelper.apiCall<Offer[]>(url, method, null, data, headers);
  }

  getOfferById(offerId: number): Observable<Offer> {
    let url: string =
      this.apiHelper.getServiceName() + this.getResource() + `/${offerId}`;
    const method = 'GET';
    const headers: HttpHeaders = this.apiHelper.getDefaultHeader();
    return this.apiHelper.apiCall<Offer>(url, method, null, null, headers);
  }

  acceptOffer(offerId: number, addOns?: CustomerAddOn[]): Observable<Offer> {
    let url: string =
      this.apiHelper.getServiceName() +
      this.getResource() +
      `/accept-offer/${offerId}`;
    const method = 'POST';
    const headers: HttpHeaders = this.apiHelper.getDefaultHeader();
    const data = {
      addOns,
    };
    return this.apiHelper.apiCall<Offer>(url, method, null, data, headers);
  }

  declineOffer(offerId: number): Observable<Offer[]> {
    let url: string =
      this.apiHelper.getServiceName() +
      this.getResource() +
      `/decline-offer/${offerId}`;
    const method = 'POST';
    const headers: HttpHeaders = this.apiHelper.getDefaultHeader();
    return this.apiHelper.apiCall<Offer[]>(url, method, null, null, headers);
  }

  updateOffers(offers: Partial<Offer>[]): Observable<Offer[]> {
    let url: string =
      this.apiHelper.getServiceName() + this.getResource() + '/update-offers';
    const method = 'POST';
    const headers: HttpHeaders = this.apiHelper.getDefaultHeader();
    const data = {
      offers,
    };
    return this.apiHelper.apiCall<Offer[]>(url, method, null, data, headers);
  }

  revokeOffer(offerId: number, vesselId): Observable<Offer[]> {
    let url: string =
      this.apiHelper.getServiceName() + this.getResource() + '/revoke-offer';
    const method = 'POST';
    const headers: HttpHeaders = this.apiHelper.getDefaultHeader();
    const data = {
      offerId,
      vesselId,
    };
    return this.apiHelper.apiCall<Offer[]>(url, method, null, data, headers);
  }
}
